<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
    <section class="container admin-dashboard-parent copy-editor-container">
        <section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Mail Queue'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
                <h1>Mail Queue</h1>
                <input type="submit" value="Refresh Content" (click)="refreshContent()">
			</div>
		</section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
        <section class="all-users-data">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-borderless table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Template Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Ignore</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of list; let i = index;">
                            <tr class="body-header" (click)="toggleSection(i)">
                                <td>{{item.template}}</td>
                                <td>{{item.data.user.email}}</td>
                                <td *ngIf="!item.ignore">false</td>
                                <td *ngIf="item.ignore">{{item.ignore}}</td>
                                <td *ngIf="item.ignoreCount">{{item.ignoreCount}}</td>
                            </tr>
                            <tr class="body-body" [ngClass]="{'hide':!lineState[i],'expanded':lineState[i]}">
                                <td colspan="3">
                                    <div class="form-group form-check">
                                        <input type="checkbox" class="form-check-input" id="ignore" name="ignore" [(ngModel)]="list[i].ignore">
                                        <label class="form-check-label" for="ignore">Ignore</label>
                                      </div>
                                    <input type="submit" value="Save" (click)="saveItem(i)">
                                    <input type="button" value="Delete" (click)="deleteItem(i)">
                                    <input type="button" value="View Email History" (click)="redirectTo()">
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </section>
    </section>
</section>